import { cancelGroupOccurrenceText } from "./group-text.ts";

/**
 * Отмена занятия серии: причина, подтверждение и вторая ступень с уроком.
 *
 * Отдельным файлом от `EntryTools.tsx` с 30.08.2026, разбор повода в шапке
 * `EntryToolButtons.tsx`. Состояние осталось у `EntryTools`: причина живёт между
 * режимами (набранная в отмене, она уезжает и с переносом), а вынос её сюда
 * стирал бы набранное при каждом закрытии формы.
 */
export function CancelOccurrenceForm({
  students,
  busy,
  reason,
  onReason,
  onCancel,
  onClose,
}: {
  /** Сколько человек задето, если это занятие группы. `null` у пары. */
  students: number | null;
  busy: boolean;
  reason: string;
  onReason: (reason: string) => void;
  onCancel: () => void;
  onClose: () => void;
}) {
  return (
    <div className="form form--row">
      {/*
        Цена массового действия стоит ПЕРЕД кнопкой, а не после неё: человек
        читает форму сверху вниз и должен узнать, что занятие снимется у всех,
        до того как нажмёт. Здесь остаётся слово, хотя в строке сетки значок
        слово заменил: предупреждение значком не заменяется, потому что человеку
        нужна причина, а не категория (раздел 8б `docs/cabinet-tables-design.md`).
        Число берётся из строки сетки, то есть считает тех, кому занятие
        производится
      */}
      {students !== null && <p className="muted">{cancelGroupOccurrenceText(students)}</p>}
      <input
        className="fld"
        value={reason}
        placeholder="причина, увидит ученик"
        onChange={(e) => onReason(e.target.value)}
      />
      {/* Шаг подтверждения: занятие снимается этим нажатием */}
      <button
        type="button"
        className="btn btn--danger is-confirm"
        disabled={busy}
        onClick={onCancel}
      >
        Отменить занятие
      </button>
      <button type="button" className="btn btn--quiet" disabled={busy} onClick={onClose}>
        Не надо
      </button>
    </div>
  );
}

/**
 * Вторая ступень отмены: к занятию уже подготовлен урок.
 *
 * Сервер отказал `lesson_exists`, и подтверждается это тем же `force`. Стоит
 * ниже формы отмены, а не вместо неё: причина, набранная выше, уезжает с этим
 * же нажатием.
 *
 * ⚠️ У группы эта ветка сегодня недостижима: своей комнаты у занятия пучка ещё
 * нет (`group_room_unavailable`), значит и уроку взяться неоткуда. Отдельных
 * слов для неё поэтому не заводится: сервер и там отвечает `lesson_exists`.
 */
export function CancelWithLessonNote({
  busy,
  onConfirm,
  onClose,
}: {
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <div className="note">
      <p>
        К этому занятию уже подготовлен урок. Отмена уберёт его в корзину: тридцать дней он
        восстановим, материал и доска на месте.
      </p>
      <div className="form__foot">
        <button type="button" className="btn btn--quiet" disabled={busy} onClick={onClose}>
          Не надо
        </button>
        {/* Тоже заливка: цена шага выросла, а не упала */}
        <button
          type="button"
          className="btn btn--danger is-confirm"
          disabled={busy}
          onClick={onConfirm}
        >
          Отменить вместе с уроком
        </button>
      </div>
    </div>
  );
}
